import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { useTranslation } from "react-i18next";
import { changeForm } from "../../../searchFlightsSlice";

function ShowReturnInput() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const roundTrip = useAppSelector(
    (state) => state.searchFlights.form.roundTrip
  );
  const disabled = useAppSelector((state) => state.searchFlights.form.disabled);

  const onChange = () => dispatch(changeForm({ roundTrip: !roundTrip }));

  return (
    <div className="search-bar-item column p-0 checkbox-item">
      <label
        className="checkbox"
        title={t("CHECKBOX_TITLE_SHOW_RETURN_FLIGHTS")}
        htmlFor="sfo-show-return"
      >
        {t("CHECKBOX_SHOWRETURN_FLIGHTS")}
      </label>
      <input
        type="checkbox"
        checked={roundTrip}
        disabled={disabled}
        onChange={onChange}
        id="sfo-show-return"
      />
    </div>
  );
}

export default ShowReturnInput;
